import React from 'react';
import { Modal, Form } from 'antd';
import {
  modalActionTypes,
  modalTypes,
  useModalDispatch,
  useModalState,
} from '../../../../../shared/lib/toggleModalVisble';
import { useShutdownNotifyToChange } from '../../api';
import { ShutdownField } from '../../../common/ui/ShutdownField';
import { fieldNames } from '../../../common/config';

const ModalContainer = ({ form }) => {
  const { type, initialValues: shutdown = {} } = useModalState();
  const dispatch = useModalDispatch();

  const close = () => dispatch({ type: modalActionTypes.resetModalData });

  const { change, loading } = useShutdownNotifyToChange();

  const handleSubmit = () => {
    form.validateFieldsAndScroll(async (err, formValues) => {
      if (!err) {
        const data = formValues[fieldNames.notifyTo]?.length
          ? formValues[fieldNames.notifyTo].map((value) => ({ id: value }))
          : [];
        await change({ shutdownId: shutdown.alertId, data });
        close();
      }
    });
  };

  return (
    <Modal
      visible={type === modalTypes.changeShutdownNotifyTo}
      onCancel={close}
      onOk={handleSubmit}
      title={`${
        shutdown.notifyTo?.length ? 'Изменить' : 'Добавить'
      } тех, кому отправить уведомление`}
      destroyOnClose
      confirmLoading={loading}
    >
      <Form colon={false}>
        <ShutdownField
          name={fieldNames.notifyTo}
          form={form}
          initialValue={
            shutdown.notifyTo?.length
              ? shutdown.notifyTo.map((val) => val.id)
              : []
          }
          editMode
          initCityId={shutdown.city?.id}
        />
      </Form>
    </Modal>
  );
};

const ChangeModal = Form.create({ name: 'change_shutdown_notifyTo' })(
  ModalContainer
);

export default ChangeModal;
